export class ClsKanbanPedido_UsuarioModel {
    public USU_ID: number;
}
